import { Pipe, PipeTransform } from "@angular/core";

import { ICategoryDetail } from "../interfaces/icountryinformation";
/**
 * Filters the categories based on whether or not they have categoryText
 *
 * Usage:
 *
 * Example:
 *  {{ countrycategoryfilter }}
 */
@Pipe({
    name: "countrycategoryfilter",
    standalone: false
})
export class CountryCategoryFilterPipe implements PipeTransform {
    transform(categoryDetails: ICategoryDetail[]): any {
        return categoryDetails.filter(item => (item.categoryText != null && item.categoryText.length > 0));
    }
}